module.exports = __webpack_public_path__ + "static/media/m_sf_12.6776a427.png";